import { ignoreSharingTip } from '../actions/publicActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(ignoreSharingTip, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLink.sharingTipsIgnored.push(actionMessage.sharingTipId);
});
